import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss']
})
export class VideoComponent implements OnInit {
  PromotionBackgroundVideoUrl: String;
  PromotionBackgroundVideoTitle: String;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.PromotionBackgroundVideoUrl = this.data.PromotionBackgroundVideoUrl;
    this.PromotionBackgroundVideoTitle = this.data.PromotionBackgroundVideoTitle;
  }

}
